import { createSelector } from 'reselect';

import { isResourceLoading } from './common';

const getStaticFooter = (state) => state.getIn(['app', 'staticFooter']);

const isStaticFooterLoading = createSelector(getStaticFooter, isResourceLoading);
const getStaticFooterData = createSelector(getStaticFooter, (data) => data.get('data'));
const getStaticFooterContent = createSelector(
    [isStaticFooterLoading, getStaticFooterData],
    (isLoading, data) => {
        let content = null;
        if (!isLoading && data) {
            const jsonContent = data.getIn(['page_content', 'content']);
            if (jsonContent) {
                content = jsonContent.toJS();
            }
        }

        return content;
    },
);

export {
    isStaticFooterLoading,
    getStaticFooterData,
    getStaticFooterContent,
};
